export const HOUR_ROW_HEIGHT_PHONE = 72;
export const HOUR_ROW_HEIGHT_COMPACT = 96;
export const HOUR_ROW_HEIGHT_DESKTOP = 140;

export const getAgendaHourRowHeight = ({ isPhone = false, isCompactViewport = false } = {}) => {
  if (isPhone) {
    return HOUR_ROW_HEIGHT_PHONE;
  }

  if (isCompactViewport) {
    return HOUR_ROW_HEIGHT_COMPACT;
  }

  return HOUR_ROW_HEIGHT_DESKTOP;
};

export const getAgendaPixelsPerMinute = (hourRowHeight) => hourRowHeight / 60;
